import { ReactElement } from 'react';

const ErrorBoundary = (): ReactElement => <div>Error</div>;

export default ErrorBoundary;
